import { FC } from "react";
import { DateRangePicker, DateRangePickerProps } from "rsuite";
import { PredefinedRanges } from "../constants";
import { useAccountTimezone } from "../../../hooks/timezone";
import { toZonedTime } from "date-fns-tz";

type FormFieldDateRangePickerProps = {
  className?: string;
  value: [Date, Date] | null;
  onChange: (value: [Date, Date] | null) => void;
} & DateRangePickerProps;

const FormFieldDateRangePicker: FC<FormFieldDateRangePickerProps> = ({
  className = "mt-2",
  value,
  onChange,
  cleanable = false,
  ...restProps
}) => {
   const { convertToTZForDateFns, tzForDateFns } =
          useAccountTimezone();
  const timezone = convertToTZForDateFns(tzForDateFns);
  const nowInAccountTimezone = toZonedTime(new Date(), timezone);
  const range = PredefinedRanges(nowInAccountTimezone);
  return (
    <div>
      <DateRangePicker
        value={value}
        onChange={onChange}
        format="yyyy-MM-dd HH:mm"
        ranges={range} // Optional: disables predefined ranges like "Today", "Yesterday"
        placeholder="Select date range"
        className={className}
        cleanable={cleanable}
        {...restProps}
      />
    </div>
  );
};

export default FormFieldDateRangePicker;
